import React from "react";
import { useRouteMatch } from "react-router";
import { Route, Switch, useHistory, Redirect } from "react-router-dom";

import BaseLayout from "../../../components/layouts/BaseLayout";
import DeviceView from "./DeviceView/DeviceView";
import DeviceHistory from "./DeviceHistory/DeviceHistory";
import FsmHistory from "./FsmHistory/FsmHistory";
import DeviceLogs from "./DeviceLogs/DeviceLogs";
import useSetState from "../../../hooks/useSetState";

const Device = () => {
  const history: any = useHistory();
  const match = useRouteMatch({
    path: "/config/devices/device/:imei/:tab",
    strict: true,
    sensitive: true,
  });
  const { imei, tab } = match?.params as any;

  const tabs = [
    { label: "Overview", value: "overview" },
    { label: "History", value: "history" },
    { label: "Fsm History", value: "fsm_history" },
    { label: "Logs", value: "logs" },
  ];

  const [{ activeTab }, setState] = useSetState({ activeTab: tab });

  const handleTabClick = (event, newValue) => {
    history.push(`/config/devices/device/${imei}/${newValue}`);
    setState({ activeTab: newValue });
  };

  return (
    <BaseLayout
      title={`Device ${imei}`}
      handleArrowClick={() => history.goBack()}
      tabs={tabs}
      handleTabChange={handleTabClick}
      activeTab={activeTab}
    >
      <Switch>
        <Route path="/config/devices/device/:imei/overview" exact>
          <DeviceView />
        </Route>
        <Route path="/config/devices/device/:imei/history">
          <DeviceHistory />
        </Route>
        <Route path="/config/devices/device/:imei/fsm_history">
          <FsmHistory />
        </Route>
        <Route path="/config/devices/device/:imei/logs">
          <DeviceLogs />
        </Route>
        <Redirect to="/config/devices/device/:imei/overview" />
      </Switch>
    </BaseLayout>
  );
};

export default Device;
